import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import React from 'react';
import { DatePickerLeisure, InfoButton } from '../../../../common/components';
import { Field } from 'redux-form';
import { hasPermission } from '../../../auth/redux/authActions';
import { addDays, parseISO, subDays } from 'date-fns';

const SingleDatePicker = ({
  isExpired,
  definition,
  advanceDays,
  minAdvanceDays,
  minDate,
  maxDays,
  startDate,
  validateStart,
  validateEnd,
}) => {
  if (isExpired) {
    return (
      <>
        <Field
          name="data.attributes.metadata.start_date"
          component={DatePickerLeisure}
          validate={validateStart}
        />
        <span className={'travel-dates-to-label'}>to</span>
        <Field
          name="data.attributes.metadata.end_date"
          component={DatePickerLeisure}
          validate={validateEnd}
        />
      </>
    );
  }

  const canBackdateCover = hasPermission('policy.backdate_cover');
  const minStartDate = canBackdateCover
    ? subDays(new Date(), 30)
    : addDays(new Date(), minAdvanceDays);
  const maxStartDate = addDays(new Date(), advanceDays);
  const minEndDate = parseISO(minDate);
  const start = startDate ? parseISO(startDate) : new Date();
  const maxEnd = maxDays ? addDays(start, maxDays) : undefined;

  return (
    <>
      <Field
        name="data.attributes.metadata.start_date"
        infoButton={definition}
        minDate={minStartDate}
        maxDate={maxStartDate}
        component={DatePickerLeisure}
        validate={validateStart}
      />

      <span className={'travel-dates-to-label'}>to</span>

      <Field
        name="data.attributes.metadata.end_date"
        key={'endDateFor' + minDate}
        minDate={minEndDate}
        component={DatePickerLeisure}
        maxDate={maxEnd}
        validate={validateEnd}
      />
    </>
  );
};

const SingleDates = ({
  show,
  isExpired,
  dateDefinition,
  tripTypeDefinition,
  advanceDays,
  minAdvanceDays,
  maxDays,
  startDate,
  minDate,
  maxEndDate,
  validateStart,
  validateEnd,
}) => {
  if (!show) {
    return null;
  }

  return (
    <FormGroup>
      <Col sm={4}>
        <ControlLabel>
          What are your travel dates? &nbsp;
          <InfoButton content={dateDefinition} />
        </ControlLabel>
      </Col>
      <Col sm={8}>
        <div className={'travel-dates'}>
          <SingleDatePicker
            isExpired={isExpired}
            definition={tripTypeDefinition}
            advanceDays={advanceDays}
            minAdvanceDays={minAdvanceDays}
            maxDays={maxDays}
            startDate={startDate}
            minDate={minDate}
            maxEndDate={maxEndDate}
            validateStart={validateStart}
            validateEnd={validateEnd}
          />
        </div>
      </Col>
    </FormGroup>
  );
};
export default SingleDates;
